import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout for /blog and /blog/$slug. Just an Outlet so each child route owns
// its own chrome (AppNav, padding, etc.). Without this, blog.tsx would try
// to be both the index AND the parent of /blog/$slug — clicking a post card
// silently does nothing because there's no Outlet to render the child into.
export const Route = createFileRoute("/blog")({
  component: () => <Outlet />,
});
